import { HttpClient } from '@angular/common/http';
import {Injectable, ViewChild} from '@angular/core';
import {ApiProvider} from "../api/api";
import {UserStats} from "../api-course-data/user-state-dto";
import {Events, Slides} from "ionic-angular";
import {LocalStorageWrapper} from "../local-storage-wrapper/local-storage-wrapper";

/*
  Generated class for the UserStatsProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class UserStatsProvider {
  @ViewChild(Slides) slides: Slides;

  userData: Map<string, UserStats>;

  constructor(public api: ApiProvider, public events: Events, public localStorage: LocalStorageWrapper) {
    this.userData = new Map<string, UserStats>();


  }

  ngAfterViewInit() {
    this.slides.freeMode = true;
  }

  stepArchiveLoaded: boolean = false;

  getStepArchive() {
    var me = this;

    return new Promise((resolve, reject) => {
      if(this.stepArchiveLoaded) {
        resolve([]);
      }

      var date = new Date();
      date.setDate(-150-date.getDate());
      me.api.callGet<UserStats>('/stats', {'date[after]': date.toDateString()}).subscribe(
        res => {
          for(var k in res) {
            var row = res[k];
            if(!this.userData.has(row.date)) {
              this.userData.set(row.date, new UserStats({date: row.date}))
            }
            this.userData.get(row.date).steps = row.steps;
            this.userData.get(row.date).activitySum = row.activitySum;
            this.userData.get(row.date).extraActivitySum = row.extraActivitySum;
            this.userData.get(row.date).mood = row.mood;
          }
          resolve(true)
        },
        res => {
          reject(res)
        }
      )


      this.stepArchiveLoaded = true;

    });
  }

  getRecentStats(days: number = 5) {
    if (!days) {
      days = 5;
    }

    let result = [];
    let d = new Date();
    for(let i = 0; i<days;i++) {
      let stat = this.userData.get(d.toISOString().substr(0,10));
      result.push(stat);
      d.setDate(d.getDate()-1);
    }
    return result;
  }

  getUserStats(date: string) {
    let me = this;
    return new Promise<UserStats>((resolve, reject) => {
      if(me.userData.has(date)) {
        resolve(me.userData.get(date));
        return ;
      }

      this.userData.set(date, new UserStats({date: date}))
      resolve(me.userData.get(date))
    })
  }

  addStats(userStats: UserStats) {
    this.userData.set(userStats.date,  userStats);
  }

  updateData(stats: UserStats) {
    this.api.callPut('/stats/'+stats.date, stats.toJSON()).subscribe((res: any) => {
      stats.steps = res.steps;
      stats.activitySum = res.activitySum;
      stats.extraActivitySum = res.extraActivitySum;
      stats.activityDaysCount = res.activityDaysCount;
      stats.groups = res.groups;

      this.events.publish('stats:updated', res);
      if(res.stateRefreshRequired) {
        this.events.publish('state:refresh');
      }
    })
  }

  addActivity(param: { date: string; type: number; length: number }) {
    return new Promise<any>((resolve, reject) => {
      this.api.callPost('/users/'+this.localStorage.getItem('api_user_id')+'/activity', param).subscribe((res: any) => {
        if(res.stateRefreshRequired) {
          this.events.publish('state:refresh');
        }
        this.addStats(new UserStats(res));
        resolve(res);
      }, reject);
    });
  }


  clearCache() {
    this.userData.clear();
  }
}



// WEBPACK FOOTER //
// ./src/providers/user-stats/user-stats.ts